import React, { useEffect } from "react";
import { useImmer } from "use-immer";
import axios from "axios";
import { SITE_URL, API } from "../const/API";
import st from "../styles/template.module.scss";
import { useNavigate } from "react-router-dom";

type OrdGroupType = [{
    "id": number,
    "code": string,
    "lang_code": string,
    "name": string,
    "ord": number
}] | null;
export default function MyCompany() {
    const nav = useNavigate();
    const [company, setCompany] = useImmer({} as any);
    const [isLoading, setIsLoading] = useImmer(true);
    const [cities, setCities] = useImmer([]);
    const [OrdGroups, setOrdGroup] = useImmer<OrdGroupType>(null);
    useEffect(() => {
        axios.get<OrdGroupType>(API + '/OrdGroups/').then((OrdGroupResponse) => {
            setOrdGroup(OrdGroupResponse.data);
        }).catch((e) => {
            if (e.response == undefined || e.response.status === 401) {
                localStorage.removeItem("user");
                nav('/login');
            }
        });
        axios.get(API + '/cities/').then((response) => {
            setCities(response.data);
            axios.get(API + '/counterparties/').then((response) => {
                setCompany(response.data[0]);
                setIsLoading(false);
            }).catch((e) => {
                console.log('mc error 36');
            });
        }).catch((e) => {
            console.log('mc error 39');
        });
    }, []);

    const getCityName = (id: number) => {
        let cityName = null;
        cities.forEach((city: any) => {
            if (city?.id === id) {
                cityName = city.name;
            }
        })
        return cityName;
    }

    const getOrdGroupName = (id: number) => {
        let groupName = null;
        OrdGroups?.forEach((group: any) => {
            if (group?.id === id) {
                groupName = group.name;
            }
        })
        return groupName;
    }
    return (
        <>
            {isLoading ? 'Loading' : <>
                <div className={st.company + ' ' + st.body_panel_body}>
                    <div className={st.section}>
                        {company?.name.length > 0 ? <h2 className={st.main_title}>{company.name}</h2> : ""}
                    </div>
                    <div className={st.section}>
                        <div className={st.company_top}>
                            {company?.imgPath ?
                                <div className={st.company_top_logo}>
                                    <img src={SITE_URL + company.imgPath} alt="logo" />
                                </div> : ""}
                            <p className={st.company_top_info}>Contact Information</p>
                        </div>
                    </div>
                    <div className={st.section}>
                        <div className={st.rowItems}>
                            {company?.name.length > 0 ?
                                <div className={st.vertical}>
                                    <p className={st.company_label}>City</p>
                                    <p className={st.box}>{getCityName(company.city_id)}</p>
                                </div> : ""}
                            {company?.site_url.length > 0 ?
                                <div className={st.vertical}>
                                    <p className={st.company_label}>Website</p>
                                    <div className={st.box}>
                                        <a href={company.site_url} target={'_blank'}>{company.site_url}</a>
                                    </div>
                                </div> : ""}
                            {company?.phones.length > 0 ?
                                <div className={st.vertical}>
                                    <p className={st.company_label}>Phone</p>
                                    <div className={st.box}>
                                        <a href={'tel:' + company.phones} target={'_blank'}>{company.phones}</a>
                                    </div>
                                </div> : ""}
                        </div>
                    </div>
                    <div className={st.section}>
                        <div className={st.rowItems}>
                            {company?.telegram.length > 0 ?
                                <div className={st.vertical}>
                                    <p className={st.company_label}>Telegram</p>
                                    <p className={st.box}> {company.telegram} </p>
                                </div> : ""}
                            {company?.whatsapp.length > 0 ?
                                <div className={st.vertical}>
                                    <p className={st.company_label}>WhatsApp</p>
                                    <p className={st.box}>{company.whatsapp}</p>
                                </div> : ""}
                            {company?.contact.length > 0 ?
                                <div className={st.vertical}>
                                    <p className={st.company_label}>Contact Person</p>
                                    <p className={st.box}>{company.contact}</p>
                                </div> : ""}
                        </div>
                    </div>
                    {company?.price_pattern ?
                        <div className={st.section}>
                            <h2 className={st.main_title}>Pricing Plans</h2>
                            <ul>
                                {JSON.parse(company.price_pattern).map((item: any) => {
                                    return (<li>{item.caption == 'day' ? '1' + item.caption : item.caption}</li>)
                                })}
                            </ul>
                        </div> : ""}
                    <div className={st.section}>
                        <h2 className={st.main_title}>Rental Conditions</h2>
                        <div className={st.rowItems}>
                            {company?.def_time_zone.length > 0 ?
                                <div className={st.vertical}>
                                    <p className={st.company_label}>Time zone</p>
                                    <p className={st.box}>{company.def_time_zone}</p>
                                </div> : ""}
                            {company?.subscription_level_id > 0 ?
                                <div className={st.vertical}>
                                    <p className={st.company_label}>Subscription level</p>
                                    <p className={st.box}>{getOrdGroupName(company.subscription_level_id)}</p>
                                </div> : ""}
                        </div>
                    </div>
                </div>
            </>}
        </>
    );
}